import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './stepbar.css';
var cx = classnames.bind(styles);
export default function StepBar(_ref) {
  var activeIndex = _ref.activeIndex,
      done = _ref.done,
      steps = _ref.steps,
      rest = _objectWithoutProperties(_ref, ["activeIndex", "done", "steps"]);

  function getIconStatusForPath(indexInput) {
    if (indexInput < activeIndex) {
      return 'done';
    }

    if (indexInput === activeIndex) {
      return done ? 'done' : 'current';
    } // indexInput > activeIndex


    return 'none';
  }

  return React.createElement("div", _extends({
    className: cx('container')
  }, rest), steps && steps.map(function (item, index) {
    // Current status for icon depending on active index
    var iconStatus = getIconStatusForPath(index);
    return React.createElement(React.Fragment, {
      key: item.copy.concat(index.toString())
    }, React.createElement("div", {
      className: cx('step')
    }, React.createElement("img", {
      alt: item.copy,
      className: cx('image'),
      src: "//static.gasbuddy.com/web/pay/svg/steps/progress-".concat(iconStatus, "-static.svg")
    }), React.createElement("span", {
      className: cx('textBase', {
        text: index <= activeIndex,
        textNone: index > activeIndex
      })
    }, item.copy)), index < steps.length - 1 && React.createElement("div", {
      className: cx('line', {
        lineCurrent: index < activeIndex,
        lineNone: index >= activeIndex
      })
    }));
  }));
}
StepBar.propTypes = {
  /** Index for current step in the array */
  activeIndex: PropTypes.number,

  /** Boolean value that "marks" current selection as done */
  done: PropTypes.bool,

  /** Array of object "steps" that includes the copy property for the caption */
  steps: PropTypes.arrayOf(PropTypes.shape({
    copy: PropTypes.string.isRequired
  })).isRequired
};
StepBar.defaultProps = {
  activeIndex: 0,
  done: false
};